module.exports = __webpack_public_path__ + "img/intro_logo.d46f4c43.png";